import Msg from '../msg/msg.vue'
import QuestionOkko from './okko/okko.vue'
import QuestionSlider from './slider/slider.vue'
import QuestionText from './text/text.vue'
import QuestionTable from './table/table.vue'

export default {
  components: {
    Msg,
    QuestionOkko,
    QuestionSlider,
    QuestionText,
    QuestionTable
  },
  props: ['type', 'ok', 'ko', 'slides', 'initialSlide', 'popup'],
  methods: {
    goto (obj, value) {
      this.$emit('goto', obj, value, value || obj.text)
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/game/question/question.js